module.exports = __webpack_public_path__ + "img/eco-responsable.7bd21aa0.jpeg";